import {
    useLocation,
    useHistory
} from 'react-router-dom';
import qs from 'qs';

export default function useQuery([ defaultQuery = {}, setValue = () => {} ] = [], method = 'replace') {
    const history = useHistory();
    const { search, pathname, hash } = useLocation();

    const setValueWithQuery = newQuery => {
        
        const re =  /^\/[^\/]*/;
        const result = pathname.match(re)[0];
        const {sport, ...query} = newQuery;
        const search = qs.stringify(newQuery);
        setValue(query);
        if (sport){
            history[method](`${result}/${sport}/?${search}${hash}`);
        }else{
            history[method](`${result}/?${search}${hash}`)
        }
    };

    return [
        {
            ...defaultQuery,
            ...qs.parse(search.substring(1))
        },
        setValueWithQuery
    ];
}
